import { CLUSTER_PINS_GRID_MAX_COUNT } from './clusterPinsGrids';

// Лимиты раскрытия кластера в пины («ромашку»):
// на десктопе рисуются все слоты сеток кодогена, на мобвебе ромашка урезается —
// сетка выбирается по видимому количеству пинов (см. getClusterPinCoordinates)
export const CLUSTER_PINS_DESKTOP_MAX_COUNT = CLUSTER_PINS_GRID_MAX_COUNT;
export const CLUSTER_PINS_PHONE_MAX_COUNT = 7;
